<div class="tvd-presentation-preview-container flex flex-col gap-6 p-6 w-[80vw] max-h-[70vh] bg-white overflow-y-scroll">
    <div class="preview-header flex justify-between items-center pb-2 neptune-border-b-1 border-sky-blue">
        <span class="text-2xl">Preview</span>
        <button (click)="onExitPreview()" class="close-preview-button border-none neptune-button-white"><img src="assets/shared-icons/neptune-icon-blue-close.svg" alt="Close"></button>
    </div>

    <!-- 
        Render tiles in their own sections, for smaller screens the sections are laid out in rows occupying full width.
        For larger screens, sections with tiles are laid out in 1, 2 or 3 columns depending on how many pillars are present.
    -->
    <div class="preview-body flex flex-col md:flex-row border-solid border-2 border-transparent box-border">
        <ng-container *ngFor="let section of renderedSections; let i = index">
            <div
            class="{{ section.class }} flex flex-col gap-4 p-2 sm:w-full"
            [ngClass]="[
                colLayoutWidth,
                i > 0 ? 'neptune-border-t-1 border-sky-blue' : '',
                i > 0 ? 'md:neptune-border-l-1 md:border-sky-blue' : ''
            ]"
            >   
                <div class="{{section.class}}-title flex justify-center items-center text-white text-base {{section.background}}">{{section.name}}</div>
                <div class="tiles flex flex-wrap gap-4 items-stretch">
                    <!-- Limit the number of tiles displayed per value pillar -->
                    <ng-container *ngFor="let tile of section.tiles">
                        <div class="card-container flex flex-col border-solid border-1 border-sky-blue rounded-[18px] min-w-40 max-w-40">
                            <div class="card-header flex gap-2 justify-start items-center min-h-sm-clamp px-4 py-3 text-sm border-solid neptune-border-b-1 border-sky-blue">
                                <img src="{{tile.iconPath}}" class="w-4 h-4" alt="metric-icon">
                                {{tile.title}}
                            </div>

                            <div class="card-body flex flex-col gap-2 px-4 py-3">
                                <span class="text-sm text-blue neptune-border-b-2 border-sky-blue pb-2">{{tile.costCurrencyCode | currencySymbol}}{{displayRoundedValues ? (tile.monetaryContribution | abbreviateNumber) : tile.monetaryContribution}} Delivered</span>
                                <span class="text-xs font-medium">{{tile.valueContribution}} {{tile.valueUnit}}</span>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </ng-container>
    </div>

    <div class="preview-footer flex gap-6 justify-end items-center pt-4 neptune-border-t-1 border-shuttle-gray">
        <button class="clear-preview-button neptune-button-white" (click)="onClearSelection()">Clear</button>
        <button class="save-preview-button neptune-button-blue" (click)="onSaveSelection()">Save</button>
    </div>
</div>